import { render, staticRenderFns } from "./Kassa.vue?vue&type=template&id=ebee7756&scoped=true"
import script from "./Kassa.vue?vue&type=script&lang=js"
export * from "./Kassa.vue?vue&type=script&lang=js"
import style0 from "./Kassa.vue?vue&type=style&index=0&id=ebee7756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebee7756",
  null
  
)

export default component.exports